import { ButtonGroup, ButtonIcon, Card, Icon, CardV2, Tooltip } from 'pepsico-ds';
import React, { useEffect, useState } from 'react'
import { appNames } from '../../constants/appNames';
import CompassModal from '../Modal/CompassModal';
import { formatNumberWithCommas, returnHyphenIfNull, splitValueWithUnit } from '../../utils/utils';
import InfoIcon from '../Icons/InfoIcon';
import { showChartDisplayError, useButtonItemsArray, vlaidateLandingPageFilters } from './CardUtils';
import { getUserClaims } from '../../utils/auth/unified-auth';
import { useSelector } from 'react-redux'
import { Divider } from 'antd';
import BuyerConButtonIcon from "../Button/BuyerConButtonIcon"
import CustomButtons from './CustomButtons';
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';


function CompassCard({ data, userDataV2,capability, selectedYear, userDataLandingPage, landingPageFilters, disabled=false }) {
    const [appName, setAppName] = useState('Compass');
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const [openModal, setOpenModal] = useState(false)
    // const [userData, setUserData] = useState({})
    const userData = useSelector((state) => state?.localData?.data?.oktaUserData);
    /* istanbul ignore next */
    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            const buttonItems = data && data?.apps && data?.apps.length > 0 ? data?.apps?.filter(item => item.isActive)?.map((app) => ({
                label: app.app,
                chartDisplay: app.chartDisplay,
                onClick: () => window.open(app.url, "_blank"), // Opens the app in a new tab
            })) : [];
            setButtonGroupItems(buttonItems)
        }
    }, [data])

    const buttonGroupDropdownItems = useButtonItemsArray(buttonGroupItems, setAppName, landingPageFilters, setOpenModal, openModal, capability);

    const enableChartDisplayButton = [appNames.compass].includes(capability) &&
        buttonGroupDropdownItems.length < 3 && buttonGroupDropdownItems?.[1]?.chartDisplay;
    


    return (
        <>
            <div className="kpi-card-header">
                                <div className="kpi-card-title">
                                    {data?.title}
                                    {
                                        data?.edfintegrated &&
                                        <Tooltip direction="bottom" text={staticNotes.EDF_NOTE} style={{ marginTop: 13 }}>
                                            <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible" }} />
                                        </Tooltip>
                                    }
                                </div>
                                <div>
                                    {
                                        buttonGroupDropdownItems.length === 2 ?
                                            <div className="kpi-card-header-icons">
                                                {BuyerConButtonIcon(enableChartDisplayButton, landingPageFilters, setOpenModal, openModal, capability, disabled)}
                                            </div>
                                            :
                                            <ButtonGroup
                                                groupDisabled = {disabled}
                                                itemCount={1}
                                                items={buttonGroupDropdownItems}
                                                showMore
                                                size="medium"
                                                className="kpiCardButtomGroup"
                                            />
                                    }
                                </div>
                            </div>
                            {
                                <div className="kpi-card-middle-content">
                                    <div className="kpi-card-middle-content-left" style={{ width: '60%' }}>
                                        {
                                            data?.currentActualSpend ?
                                                <div className="kpi-card-alphanumeric-value">
                                                    {

                                                        <>
                                                            <div className='kpi-card-numeric-value' style={{ fontSize: 50 }}>
                                                                {splitValueWithUnit(data?.currentActualSpend)?.['numericValue']}
                                                            </div>
                                                            <div className="kpi-card-alpha-value" style={{ display: "flex", alignItems: 'flex-end' }}>
                                                                {splitValueWithUnit(data?.currentActualSpend)?.['unit']}
                                                            </div>
                                                        </>
                                                    }

                                                    <InfoIcon style={{ 'line-height': '4rem' }} text={`Covered 'Buy Plan' as on ${data?.yearMonth?.replace(" ", ": ") || 'N/A'}`} direction='right'/>
                                                </div>
                                                :
                                                <div className="kpi-card-alphanumeric-value">
                                                    <div className='kpi-card-numeric-value'>N/A<sup><InfoIcon text="Data is not available for the given filter combination. Please adjust your selection." direction='right'/></sup></div>
                                                </div>
                                        }
                                        <div>
                                            
                                            <div className="kpi-card-numeric-value-tagline">{data?.description}</div>
                                            <div className="kpi-card-numeric-value-tagline">
                                                FY Volume Coverage: <span style={{ fontWeight: 700 }}>{data.volumeCoverage || 0} %</span>
                                            </div>
                                        </div>
                                        <div className="kpi-card-last-update" style={{ width: '100%', textAlign: 'left' }}>{data?.lastUpdate && data?.refreshFrequency? `${data.lastUpdate} | ${data.refreshFrequency}`: data?.lastUpdate || data?.refreshFrequency || ''}</div>
                                    </div>
                                    <div className="kpi-card-middle-content-right">
                                        <div className="kpi-card-last-year-value">
                                            <span className="last-year">LY</span>
                                            {
                                                data?.lastYearActualSpend ?
                                                    <>
                                                        {
                                                            capability != "Contract" && capability != appNames.sustainability && capability != appNames.coman ?
                                                                <>
                                                                    <span className="last-year-value">{splitValueWithUnit(data?.lastYearActualSpend)?.['numericValue']}{splitValueWithUnit(data?.lastYearActualSpend)?.['unit']}</span>
                                                                </> :
                                                                <span className="last-year-value">{formatNumberWithCommas(data?.lastYearActualSpend)}</span>
                                                        }
                                                    </> : <span className="last-year-value">N/A</span>
                                            }
                                        </div>
                                        {
                                            data?.percent ?
                                                <>
                                                    <div className="kpi-card-percentage-value">{data?.percent}%
                                                        <Icon
                                                            alt="alt value"
                                                            icon={parseFloat(data?.percent) == 0 ? "" : (parseFloat(data?.percent) > 0 ? "arrow_upward" : "arrow_downward")}
                                                            size="small"
                                                            style={{ color: '#fff' }}
                                                        />
                                                    </div>
                                                </> : ""
                                        }
                                    </div>
                                </div>
                            }
                            
                            <div className="kpi-card-footer">
                                <CustomButtons appList={data?.apps} disabled={disabled}/>
                            </div>
            {
                openModal && capability == appNames.compass && <CompassModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} userDataV2={userDataV2} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
        </>
    )
}

export default CompassCard